import { useEffect } from "react";
import { Link } from "react-router-dom";
import type { MediaItem } from "@/mocks/movies";
import { typeMeta } from "@/lib/media";

interface WatchModalProps {
  open: boolean;
  item: MediaItem;
  onClose: () => void;
}

export default function WatchModal({ open, item, onClose }: WatchModalProps) {
  useEffect(() => {
    if (!open) return;
    const onKey = (event: KeyboardEvent) => {
      if (event.key === "Escape") onClose();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[70] flex items-center justify-center px-4">
      <button
        type="button"
        aria-label="关闭观看提示"
        onClick={onClose}
        className="absolute inset-0 cursor-pointer bg-foreground-950/50"
      />
      <div className="relative w-full max-w-md rounded-lg border border-background-200 bg-background-50 p-6">
        <div className="flex items-start justify-between gap-4">
          <div className="flex items-center gap-2">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-100 text-primary-700">
              <i className="ri-play-circle-line text-lg" />
            </span>
            <div>
              <h2 className="font-heading text-base font-bold text-foreground-950">在线观看</h2>
              <p className="text-[11px] text-foreground-500">{typeMeta[item.type].label} · 演示入口</p>
            </div>
          </div>
          <button
            type="button"
            aria-label="关闭"
            onClick={onClose}
            className="flex h-8 w-8 shrink-0 cursor-pointer items-center justify-center rounded-md border border-background-200 text-foreground-600"
          >
            <i className="ri-close-line" />
          </button>
        </div>

        <div className="mt-5 rounded-md border border-dashed border-accent-300 bg-accent-50 p-4">
          <p className="text-xs font-medium text-accent-900">当前为演示状态</p>
          <p className="mt-2 text-[12px] leading-relaxed text-foreground-600">
            「{item.title}」暂未接入真实片源，播放功能尚未开放。你可以在详情页查看剧情介绍与主创信息，或从相关推荐里继续浏览同类型作品。
          </p>
        </div>

        <div className="mt-5 flex flex-col gap-2 sm:flex-row">
          <button
            type="button"
            onClick={onClose}
            className="inline-flex h-10 flex-1 cursor-pointer items-center justify-center whitespace-nowrap rounded-md bg-primary-500 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            继续查看详情
          </button>
          <Link
            to={`/category/${item.type}`}
            className="inline-flex h-10 flex-1 cursor-pointer items-center justify-center gap-1 whitespace-nowrap rounded-md border border-background-300 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
          >
            浏览同类资源
            <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </div>
    </div>
  );
}